import * as pd from '@/property-details/components/property-details-content-styles';
import { Placeholder } from 'rsuite';
import styled from 'styled-components';
import {
  SkeletonBlock,
  SkeletonTitle,
  SolidSkeletonSection,
} from './generic-skeleton-placeholders';

const PropertyDetailsSkeletonWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

const ImageGallerySkeleton = styled(Placeholder.Graph)`
  display: flex;
  height: 258px !important;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 37px;
`;

const SkeletonChartsWrapper = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: auto auto;
`;

const SkeletonChart = () => <SolidSkeletonSection height={300} width={300} />;

function SkeletonCharts() {
  return (
    <SkeletonChartsWrapper>
      <SkeletonChart />
      <SkeletonChart />
      <SkeletonChart />
      <SkeletonChart />
    </SkeletonChartsWrapper>
  );
}

const PropertyInfoSkeleton = () => (
  <PropertyDetailsSkeletonWrapper>
    <SkeletonTitle />
    {/* Violation Block */}
    <SkeletonBlock />
    <SolidSkeletonSection height={15} margin="0px 0px 10px 0px" />
    <Placeholder.Paragraph rows={3} />
    <SolidSkeletonSection height={20} margin="30px 0px 20px 0px" />
    <SkeletonTitle />
    <Placeholder.Paragraph rows={4} />
    <SolidSkeletonSection height={20} margin="20px 0px 10px 0px" />
    <Placeholder.Paragraph rows={4} />
    <SolidSkeletonSection height={20} margin="20px 0px 10px 0px" />
    {/* Map */}
    <SkeletonBlock />
    <SkeletonTitle />
    <Placeholder.Paragraph rows={2} />
  </PropertyDetailsSkeletonWrapper>
);

const PropertyVisSkeleton = () => (
  <PropertyDetailsSkeletonWrapper>
    <SkeletonTitle />
    <SkeletonBlock height={419} />
    <SkeletonTitle />
    <SkeletonCharts />
  </PropertyDetailsSkeletonWrapper>
);

export function PropertyDetailsSkeleton() {
  return (
    <PropertyDetailsSkeletonWrapper>
      <ImageGallerySkeleton active />
      <pd.DetailsWrapper>
        <PropertyInfoSkeleton />
        <pd.Spacer />
        <PropertyVisSkeleton />
      </pd.DetailsWrapper>
    </PropertyDetailsSkeletonWrapper>
  );
}

export function ActivityFeedSkeleton() {
  return (
    <PropertyDetailsSkeletonWrapper>
      <pd.Wrapper>
        <pd.DetailsWrapper>
          <SkeletonTitle width="30%" />
        </pd.DetailsWrapper>

        <pd.DetailsWrapper>
          <SkeletonTitle width="40%" />
          <Placeholder.Paragraph rows={3} style={{ marginBottom: '20px' }} />
          <Placeholder.Paragraph rows={2} style={{ marginBottom: '20px' }} />
          <Placeholder.Paragraph rows={4} style={{ marginBottom: '30px' }} />

          <pd.Spacer />

          <SkeletonTitle width="50%" />
          <Placeholder.Paragraph rows={5} />
        </pd.DetailsWrapper>
      </pd.Wrapper>
    </PropertyDetailsSkeletonWrapper>
  );
}
